import { PhotoIcon } from "@heroicons/react/24/solid"
import { useEffect, useState } from "react"

export function VFImage({src, ...props}){

    const [count, setCount] = useState() 
    const [loaded, setLoaded] = useState(false) 

    const safeSrc = typeof src === "string" ? src : ""
    const isRemoteImageProxy = safeSrc.startsWith("/api/remoteImage")
    const maxRetries = isRemoteImageProxy ? 0 : 4
    const hasQuery = safeSrc.includes("?")
    const resolvedSrc = count ? `${safeSrc}${hasQuery ? "&" : "?"}retry=${count}` : safeSrc

    useEffect(()=>{
        setCount(undefined)
        setLoaded(false)
    }, [safeSrc])

    function error(e){
        const nc = count ? count + 1 : 1
        const timeout = (nc ** 2) * 1000
        if( nc <= maxRetries){
            setTimeout(()=>{
                setCount(nc)
            },timeout)
        }
    }
    return <>
            {safeSrc && <img 
                draggable="false" 
                src={resolvedSrc}
                alt={props.alt ?? ""}
                {...props}
                className={props.className + (loaded ? ` ${props.rounded ? "rounded-full" : ""} ${props.shadow ? "shadow-md" : ""}` : ' invisible max-w-[0] !mr-0')}
                onLoad={()=>setLoaded(true)}
                onError={error}
                />}
            {!loaded && <PhotoIcon {...props} className={(props.className || "") + " text-gray-400"}/>}
            
            </>

}
